import {Controller} from "stimulus";

export default class extends Controller {
  static targets = ["contact", "message"];

  initialize() {
    document.addEventListener('dashboard.queue.remove', event => {
      if (this.element.dataset.id === event.detail) {
        this.removeContact();
      }
    });
    document.addEventListener('dashboard.call.ended', event => {
      if (this.element.dataset.id === event.detail.id) {
        this.removeContact();
      }
    });
  }

  startCall(e) {
    this.callController.startCall(this.data.get('url'));
  }

  setMessage(message) {
    if (this.hasMessageTarget) {
      this.messageTarget.innerHTML = message;
    }
  }

  removeContact() {
    this.element.remove();
  }

  get callController() {
    return this.application.getControllerForElementAndIdentifier(document.getElementById('call-screen'), "call")
  }
}